import { useAuth } from "@/contexts/AuthContext";
import { useLocation, useNavigate } from "react-router-dom";
import { LayoutDashboard, ClipboardList, Calendar, FileBarChart, Settings } from "lucide-react";
import { cn } from "@/lib/utils";

const adminTabs = [
  { to: "/", label: "Ana Sayfa", icon: LayoutDashboard },
  { to: "/work-orders", label: "İş Emirleri", icon: ClipboardList },
  { to: "/calendar", label: "Takvim", icon: Calendar },
  { to: "/reports", label: "Raporlar", icon: FileBarChart },
  { to: "/settings", label: "Ayarlar", icon: Settings },
];

const techTabs = [
  { to: "/", label: "İşlerim", icon: ClipboardList },
  { to: "/calendar", label: "Takvim", icon: Calendar },
];

export default function MobileBottomNav() {
  const { role } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
  const tabs = role === "admin" ? adminTabs : techTabs;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 flex border-t border-border bg-background">
      {tabs.map((tab) => {
        const isActive = location.pathname === tab.to;
        return (
          <button
            key={tab.to}
            onClick={() => navigate(tab.to)}
            className={cn(
              "flex flex-1 flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition-colors",
              isActive ? "text-primary" : "text-muted-foreground"
            )}
          >
            <tab.icon className="h-5 w-5" />
            {tab.label}
          </button>
        );
      })}
    </nav>
  );
}
